import React, { useCallback, useMemo, useState } from "react";
import { Button, Card, Row, Typography } from "antd";
import { RateNegotiationConfigEnum } from "src/components/RateNegotiationModal/interfaces";
import { EMPLOYEE_ROLES } from "@src/appV2/Employee/constants";
import { EditStatusModal } from "./EditStatusModal";
import { Facility } from "src/interface";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

const { Text } = Typography;

const fallbackURL =
  "https://workers.clipboardhealth.com/hc/en-us/articles/29561039030935-How-do-I-use-the-Rate-Negotiation-Feature";

interface IRateNegotiationStatusCard {
  isAdmin?: boolean;
  facility: {
    rateNegotiation?: RateNegotiationConfigEnum;
    userId?: string;
    name?: string;
    fullAddress?: Facility["fullAddress"];
  };
  roles?: string[];
  updateFacilityData: (data: { rateNegotiation: RateNegotiationConfigEnum }) => Promise<void>;
}

function RateNegotiationStatusCard({
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isAdmin = false,
  facility,
  roles,
  updateFacilityData,
}: IRateNegotiationStatusCard) {
  const learnMoreLink = useCbhFlag(CbhFeatureFlag.SUPPORT_LINKS, {
    defaultValue: {
      RATE_NEGOTIATION_ADMIN: fallbackURL,
    },
  }).RATE_NEGOTIATION_ADMIN;
  const editButtonVisible = useMemo(() => roles?.includes(EMPLOYEE_ROLES.SHIFT_PRICING), [roles]);
  const [editModalVisible, setEditModalVisible] = useState<boolean>(false);
  const TitleComponent = useMemo(
    () => (
      <Row>
        <Text data-testid="rate-negotiation-status-card-title-text">
          Rate Negotiation Status: {facility.rateNegotiation === "ON" ? "ON" : "OFF"}
        </Text>
      </Row>
    ),
    [facility.rateNegotiation]
  );
  const editRateNegotiationStatus = useCallback(() => {
    setEditModalVisible(true);
  }, []);

  return (
    <>
      <Card
        title={TitleComponent}
        extra={
          editButtonVisible && (
            <Button
              data-testid="rate-negotiation-status-card-edit-button"
              type="link"
              onClick={editRateNegotiationStatus}
            >
              Edit
            </Button>
          )
        }
      >
        <a style={{ paddingLeft: 12 }} href={learnMoreLink} target="_blank">
          Click to learn more about what this means
        </a>
      </Card>
      {facility.userId && (
        <EditStatusModal
          visible={editModalVisible}
          title={TitleComponent}
          setVisibility={setEditModalVisible}
          currentStatus={facility.rateNegotiation}
          updateFacilityData={updateFacilityData}
          facilityId={facility.userId}
        />
      )}
    </>
  );
}

export { RateNegotiationStatusCard };
